document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('quick-add-modal').forEach(modal => {
      if (modal.hasAttribute('open')) {
        window.dispatchEvent(new Event('scroll'));
      }
    });
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['open']
  });

  const bssNetTerm = document.querySelector("#bss-b2b-net-term-button-wrapper");
  const checkoutBtn = document.querySelector(".cart__checkout-button[type='submit']")
  checkoutBtn.insertAdjacentElement("beforeBegin", bssNetTerm);

  const tags = BSS_B2B.nt.ntRules.map(rule => rule.ct).flat();
  const customerTags = BSS_B2B.shopData.customer.tags || [];
  const hasMatchingTag = customerTags.some(tag => tags.includes(tag));
  if (hasMatchingTag) {
    const checkoutBtn = document.querySelector('.cart__checkout-button');
    const otherCheckoutBtn = document.querySelector('.cart__footer-dynamic-checkout');
    
    if (checkoutBtn) {
      checkoutBtn.style.display = 'none';
    }
    if (otherCheckoutBtn) {
      otherCheckoutBtn.style.display = 'none';
    }
  }
});

